// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f8Cy","content":"styles_content__1SSTo"};